export enum TreasuryTransferFilterEnum {
  'payment' = 'payment',
  'refund' = 'refund',
}
